import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  styled,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from 'framer-motion';

// We'll style the section container for spacing and background
const StyledServicesSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.background.default, // Use a contrasting background
}));

const services = [
  "Custom Website Development – Small business sites, personal portfolios, and complex apps",
  "UI/UX Design & Responsive Layouts – Clean, modern, user-friendly interfaces",
  "Backend Systems & API Integration – Secure, scalable, and reliable",
  "SEO & Performance Optimization – Faster, discoverable, and optimized for search engines",
  "Hosting & Cloud Deployment – Vercel, Render, and other cloud solutions",
];

const reasonsToWork = [
  "You’ll work directly with Timothy, no middlemen",
  "Personalized solutions for your business goals",
  "Modern design and technical expertise in one package",
];

// Define animation variants for each section
const sectionVariants = {
  hidden: { y: 50, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.8, ease: "easeInOut" } },
};

const ServicesSection = () => {
  return (
    <StyledServicesSection>
      <Container maxWidth="md">
        <Typography variant="h3" component="h2" align="center" fontWeight="bold" gutterBottom>
          Services
        </Typography>

        {/* This is the new, centered services list */}
        <Grid container justifyContent="center" sx={{ mt: 4 }}>
          <Grid item xs={12} sm={10} md={8}>
            <motion.div
              variants={sectionVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              {services.map((service, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                  <CheckCircleIcon color="secondary" sx={{ mr: 1, mt: 0.5 }} />
                  <Typography variant="body1" color="text.primary">
                    {service}
                  </Typography>
                </Box>
              ))}
            </motion.div>
          </Grid>
        </Grid>

        {/* This is the existing centered "Why work with me" section */}
        <Grid container justifyContent="center" sx={{ mt: 4 }}>
          <Grid item xs={12} sm={10} md={8}>
            <motion.div
              variants={sectionVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Box sx={{ p: 3, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                <Typography variant="h5" component="h3" fontWeight="bold" gutterBottom>
                  Why work with me:
                </Typography>
                {reasonsToWork.map((reason, index) => (
                  <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <CheckCircleIcon color="secondary" sx={{ mr: 1, mt: 0.5 }} />
                    <Typography variant="body1" color="text.primary">
                      {reason}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </StyledServicesSection>
  );
};

export default ServicesSection;